import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';

var QrcodePopup =
/** @class */
function (_super) {
  __extends(QrcodePopup, _super);

  function QrcodePopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 二维码弹窗 */


    _this.popupVisible = false;
    /** 默认不勾选 */

    _this.neverDisplay = false;
    return _this;
  }

  Object.defineProperty(QrcodePopup.prototype, "visible", {
    /** 二维码是否可见 */
    get: function get() {
      return store.state.util.popup.visible;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(QrcodePopup.prototype, "popup", {
    /** 二维码链接 */
    get: function get() {
      return store.state.util.popup;
    },
    enumerable: false,
    configurable: true
  });

  QrcodePopup.prototype.onVisibleChange = function (val) {
    this.popupVisible = val;
  };
  /**
   * 点击关闭
   */


  QrcodePopup.prototype.onClickCloseQrcode = function () {
    this.popupVisible = false;
    store.commit('setPopupVisible', false); // 调用callback

    if (this.popup.closeCb) {
      this.popup.closeCb({
        neverDisplay: this.neverDisplay
      });
    } // 充值neverDisplay


    this.neverDisplay = false;
  };

  QrcodePopup.prototype.onClickNeverDisplay = function () {
    this.neverDisplay = !this.neverDisplay;
  };

  __decorate([Watch('visible')], QrcodePopup.prototype, "onVisibleChange", null);

  QrcodePopup = __decorate([Component({
    name: 'QrcodePopup'
  })], QrcodePopup);
  return QrcodePopup;
}(Vue);

export default QrcodePopup;